import { useState } from 'react';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputBase from '@mui/material/InputBase';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';
import Backdrop from '@mui/material/Backdrop';
import { DaySelectionStyle } from 'modules/report/styles/dropdown-style';

const useStyles = makeStyles(DaySelectionStyle);
const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {},
  '& .MuiInputBase-input': {
    background: '#F5F5F5',
    border: '1px solid #FFFFFF',
    borderRadius: '98px',
    width: '210px',
    margin: '0 auto 0',
    boxShadow: '-2px -2px 4px #FFFFFF, 4px 4px 10px rgba(0, 0, 0, 0.1)',
    fontFamily: 'dana-bold',
    fontSize: '12px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#753CBE',
    padding: '6px 0 3px ',

    '&:focus': {
      background: '#F4F4F4',
      border: '1px solid #FFFFFF',
      borderRadius: '98px',
      margin: '0rem auto',
      boxShadow: '-2px -2px 4px #FFFFFF, 4px 4px 10px rgba(0, 0, 0, 0.1)'
    },
    [theme.breakpoints.up('md')]: {
      padding: '15px 0 13px',
      width: '320px',
      height: '49px',
      borderRadius: '16px',
      fontSize: '20px',
      '&:focus': {
        borderRadius: '16px'
      }
    }
  }
}));

const MyIcon = (props) => {
  const { style, ...otherProps } = props;
  const colorStyle = {
    color: '#707070',
    marginTop: '1px',
    marginRight: '8px'
  };
  const styles = { ...style, ...colorStyle };
  return (
    <ExpandMoreIcon
      sx={{ fontSize: { md: '40px' } }}
      {...otherProps}
      style={styles}
    />
  );
};

export function DaysDropdown(props) {
  const { chosen, setChosen, openDateModalHandler, items } = props;
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const handleToggle = () => setOpen(!open);
  const handleClose = () => setOpen(false);

  const handleChange = (event) => {
    setChosen(event.target.value);
    if (event.target.value === 'Date Selection') {
      openDateModalHandler();
    }
  };

  const hideSelectedDateItems = (choice) =>
    choice !== 'Date Selection' && typeof choice !== 'number';

  const dateSelectionIsActive = (index) =>
    hideSelectedDateItems(chosen) && index == 5;

  return (
    <>
      <Backdrop
        sx={{
          color: '#ffffff',
          zIndex: '10',
          background: 'rgba(216, 216, 216, 0.37)'
        }}
        open={open}
        onClick={handleClose}
      />
      <FormControl sx={{ m: 1 }} variant="standard">
        <Select
          onOpen={handleToggle}
          onClose={handleToggle}
          id="demo-customized-select-native"
          value={chosen}
          IconComponent={MyIcon}
          classes={{
            select: `${classes.selectStyle}`
          }}
          dir="ltr"
          onChange={handleChange}
          input={<BootstrapInput />}
          MenuProps={{
            style: { marginLeft: '5px', marginTop: '10px' },
            classes: { paper: classes.select }
          }}
        >
          {items.map((choice, index) => {
            return (
              <MenuItem
                key={choice}
                sx={{
                  display: hideSelectedDateItems(choice) && 'none !important',
                  background:
                    dateSelectionIsActive(index) && '#FFFFFF !important',
                  border:
                    dateSelectionIsActive(index) &&
                    '1px solid rgba(117, 60, 190, 1) !important',
                  color:
                    dateSelectionIsActive(index) &&
                    'rgba(117, 60, 190, 1) !important'
                }}
                dir="ltr"
                value={choice}
                classes={{ selected: classes.ItemSelected }}
              >
                {choice === 'Date Selection' ? (
                  'Date Selection'
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {typeof choice === 'number' && (
                      <span style={{ marginRight: '4px', fontWeight: '400' }}>
                        From
                      </span>
                    )}
                    <div
                      className={`${classes.numberWeight} ${{
                        selected: classes.numberWeight
                      }}`}
                    >
                      {choice === 365 ? '1 Year ' : choice}
                    </div>
                    {choice !== 365 && typeof choice == 'number' ? (
                      'days ago'
                    ) : choice == 365 ? (
                      <span style={{ paddingLeft: '1px' }}>ago</span>
                    ) : (
                      ''
                    )}
                  </div>
                )}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </>
  );
}
